enum AiImageFilterType {
    ALL = 'all',
    INTERNAL_USER = 'internal_user',
    BOOKMARKED = 'bookmarked',
}

export default AiImageFilterType;
